import { createAPI } from '@common'
export default {
  // 获取视频详情
  getMamMaterialAudioDetail: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0w20nbn0nbufsjbm0bvejp0efubjm', 'GET', config, vconfig)
}
